import React, { createContext, useContext, useState } from "react";

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("sq"); // Gjuha e parazgjedhur është shqip

  // Funksioni për të ndryshuar gjuhën në shqip
  const setAlbanian = () => {
    setLang("sq");
  };

  // Funksioni për të ndryshuar gjuhën në anglisht
  const setEnglish = () => {
    setLang("en");
  };

  return (
    <LanguageContext.Provider value={{ lang, setAlbanian, setEnglish }}>
      {children}
    </LanguageContext.Provider>
  );
};